import React, { useState, useRef } from 'react';
import { useForm } from 'react-hook-form';
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import ModalHeader from 'react-bootstrap/ModalHeader'
import ModalTitle from 'react-bootstrap/ModalTitle'
import ModalBody from 'react-bootstrap/ModalBody'
import ModalFooter from 'react-bootstrap/ModalFooter'

import './Popup.css';

export default function Popup(props) {

    const { register, handleSubmit, errors } = useForm();    
    const onSubmit = data => {
        alert(JSON.stringify(data));
    };
    const intialValues = {
        firstName: "firstname",
        lastName: "lastname",
        email: "email",
        age: -1
    };

    return (        
        <Modal show={props.show} onHide={props.handleClose} animation={false}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <ModalHeader closeButton>
                    <ModalTitle>Modal heading</ModalTitle>
                </ModalHeader>
                <ModalBody>
                    Woohoo, you're reading this text in a modal!   
                    
                    <label htmlFor="firstName">First Name</label>
                    <input
                        defaultValue={intialValues.firstName}
                        name="firstName"
                        placeholder="bill"
                        ref={register({ validate: value => value !== "firstName" })}
                    />
                    {errors.firstName && <p>Your name is not bill</p>}

                    <label htmlFor="lastName">Last Name</label>
                    <input
                        defaultValue={intialValues.lastName}
                        name="lastName"
                        placeholder="luo"
                        ref={register({ validate: value => value.length > 3 })}
                    />
                    {errors.lastName && <p>Your last name is less than 3 characters</p>}

                    <label htmlFor="email">Email</label>
                    <input
                        defaultValue={intialValues.email}
                        name="email"
                        placeholder="bluebill1049@hotmail.com"
                        type="email"
                        ref={register}
                    />
                    <label htmlFor="age">Age</label>
                    <input
                        defaultValue={intialValues.age}
                        name="age"
                        placeholder="0"
                        type="text"
                        ref={register({
                        validate: {
                            positiveNumber: value => parseFloat(value) > 0,
                            lessThanHundred: value => parseFloat(value) < 200
                        }
                        })}
                    />
                    {errors.age && errors.age.type === "positiveNumber" && (
                        <p>Your age is invalid</p>
                    )}
                    {errors.age && errors.age.type === "lessThanHundred" && (
                        <p>Your age should be greater than 200</p>
                    )}                                    
                </ModalBody>
                <ModalFooter>
                    <Button variant="secondary" onClick={props.handleClose}>
                        Close
                    </Button>
                    <Button type="submit">Submit</Button>
                </ModalFooter>
            </form>
        </Modal>
    );
}